import {defineMessages} from 'react-intl';

const messages = defineMessages({
  formField_DurationPicker_hours: {
    id: 'formField_DurationPicker_hours',
    defaultMessage: 'hours'
  },
  formField_DurationPicker_minutes: {
    id: 'formField_DurationPicker_minutes',
    defaultMessage: 'minutes'
  },
  formValue_select: {
    id: 'formValue_select',
    defaultMessage: 'select'
  }
});

export default messages;
